import React from 'react';

interface MatchAccuracyBadgeProps {
  matchedCount: number;
  totalCount: number;
  matchedAngles: string[];
}

export default function MatchAccuracyBadge({
  matchedCount,
  totalCount,
  matchedAngles,
}: MatchAccuracyBadgeProps) {
  const getBadge = () => {
    if (matchedCount === totalCount) {
      return <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-sm">✅ Full Match</span>;
    } else if (matchedCount >= totalCount / 2) {
      return <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-sm">⚠️ Partial Match</span>;
    } else {
      return <span className="bg-red-100 text-red-800 px-2 py-1 rounded text-sm">❌ Low Match</span>;
    }
  };

  return (
    <div className="mb-4 space-y-1">
      <h2 className="text-sm text-gray-500">Match Accuracy:</h2>
      {getBadge()}
      <p className="text-xs text-gray-600">
        Matched {matchedCount} out of {totalCount} image angles
      </p>
      {matchedAngles.length > 0 && (
        <ul className="list-disc list-inside text-xs text-gray-500">
          {matchedAngles.map((angle, i) => (
            <li key={i}>{angle}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
